module.exports = __webpack_public_path__ + "img/cateicon4.9c640404.svg";